import { getActingTonightChoiceIdByTitle } from '@/pages/Onboarding/options/ActingTonight/utils/getActingTonightChoice';
import { getAgeIdByTitle } from '@/pages/Onboarding/options/Age/utils/getAgeIdByTitle';
import { getBodyShapeIdByTitle } from '@/pages/Onboarding/options/BodyShape/utils/getBodyShapeIdByTitle';
import { getBreastSizeIdByTitle } from '@/pages/Onboarding/options/BreastSize/utils/getBreastSizeIdByTitle';
import { getButtSizeIdByTitle } from '@/pages/Onboarding/options/ButtSize/utils/getButtSizeIdByTitle';
import { getHairColorIdByTitle } from '@/pages/Onboarding/options/HairColor/utils/getHairColorIdByTitle';
import { getPerfectPersonalityChoiceIdByTitle } from '@/pages/Onboarding/options/Personality/utils/getPerfectPersonalityChoice';
import { getSettingSelectorChoiceIdByTitle } from '@/pages/Onboarding/options/SettingSelector/utils/getSettingSelectorChoice';
import { getTimeOfNightChoiceIdByTitle } from '@/pages/Onboarding/options/TimeOfNight/utils/getTimeOfNightChoice';
import { getTwistGeneratorChoiceIdByTitle } from '@/pages/Onboarding/options/TwistGenerator/utils/getTwistGeneratorChoice';
import { getVibeCheckChoiceIdByTitle } from '@/pages/Onboarding/options/VibeCheck/utils/getVibeCheckChoice';

import { layoutDataDefault } from '../constants';
import { LayoutDataType } from '../types';

type LayoutDataTypeFromUser = {
  gender: 'male' | 'female';
  age: string;
  hair_color: string;
  ethnicity: string;
  body_shape: string;
  breast_size: string;
  butt_size: string;
  acting_tonight: string;
  personality: string;
  time_of_night: string;
  vibe_check: string;
  twist_generator: string;
  setting_selector: string;
  name: string;
  email: string;
};

export const normalizeOnbDataToForm = (
  onb_data: LayoutDataTypeFromUser,
): LayoutDataType => {
  return {
    ...layoutDataDefault,
    gender: onb_data.gender || null,
    age: getAgeIdByTitle(onb_data.age),
    hair_color: getHairColorIdByTitle(onb_data.hair_color),
    body_shape: getBodyShapeIdByTitle(onb_data.body_shape),
    ethnicity: (onb_data.ethnicity as LayoutDataType['ethnicity']) || null,
    breast_size: getBreastSizeIdByTitle(onb_data.breast_size),
    butt_size: getButtSizeIdByTitle(onb_data.butt_size),
    acting_tonight: getActingTonightChoiceIdByTitle(onb_data.acting_tonight),
    personality: getPerfectPersonalityChoiceIdByTitle(onb_data.personality),
    time_of_night: getTimeOfNightChoiceIdByTitle(onb_data.time_of_night),
    vibe_check: getVibeCheckChoiceIdByTitle(onb_data.vibe_check),
    twist_generator: getTwistGeneratorChoiceIdByTitle(onb_data.twist_generator),
    setting_selector: getSettingSelectorChoiceIdByTitle(
      onb_data.setting_selector,
    ),
    name: onb_data.name || '',
    email: onb_data.email || '',
  };
};
